<template>
  <div class="container">
    <div class="row">
      <div class="page-body">
        <div class="info-page-body support-page-body">
          <div class="support-title">
            <h1 class="page-title">{{ $t('customerSupport') }}</h1>
          </div>

          <ul class="support-product-list">
            <li>
              <router-link :to="{ name: 'FlightsSupport', params: {locale: $i18n.locale} }" :title="$t('flights')">
                <i class="fal fa-plane"></i>
                <span>{{ $t('flights') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'HotelsSupport', params: {locale: $i18n.locale} }" :title="$t('hotels')">
                <i class="fal fa-hotel"></i>
                <span>{{ $t('hotels') }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SupportPage',
  data () {
    return {
      title: 'Customer Support'
    }
  },

  metaInfo: {
    title: 'Customer Support - Get Help With Your Booking',
  },

  metaInfo() {
    let self = this;
    return {
      title: self.$t('customerSupport') + ' - ' + self.$t('getHelpWithYourBooking')
    }
  },

  methods: {
  },
  
  computed: {
  }
}
</script>
